import { z } from 'zod';

export const revcatOfferingMetadata = z.object({
  popularProductId: z.string().optional(),
  hidePopularProductTag: z.boolean().optional(),
  subtitleStyle: z.enum(['default', 'no-box']).optional(),
  noAdsUpgradeProductId: z.string().optional(),
  isFamilyPlanOffering: z.boolean().optional(),
  pointsLimitedSubscription: z.boolean().optional(),
  hideAuthorSupportText: z.boolean().optional(),
  hasFreeTrialOption: z.boolean().optional(),
  staticIntroDays: z.number().optional(),
  baseAnnualProductIds: z
    .object({
      android: z.string().optional(),
      ios: z.string().optional(),
    })
    .optional(),
});

export type RevcatOfferingMetadata = z.infer<typeof revcatOfferingMetadata>;
